import lessonSizes from '../data/lessonSizes.json';
import { TLessonNativeSize } from './parseLessonProjectMetadata';

type TLessonSizeEntry = {
  lessonWidth: number;
  lessonHeight: number;
};

const lessonSizeByPath = lessonSizes as Record<string, TLessonSizeEntry>;

export const getLessonPathFromSrc = (lessonSrc: string) => {
  const { pathname } = new URL(lessonSrc);
  return decodeURIComponent(pathname.replace(/^\//, ''));
};

export const getLessonSizeFromSrc = (lessonSrc: string): TLessonNativeSize | null => {
  const entry = lessonSizeByPath[getLessonPathFromSrc(lessonSrc)];
  if (!entry) {
    return null;
  }

  return {
    width: entry.lessonWidth,
    height: entry.lessonHeight,
  };
};
